import React, { useState, useEffect } from "react";

import bannerImg from "../../assets/WEBINAR-RPA-banner.jpg";
import manufacturingImg from "../../assets/manufacture.png";

import { FaRobot, FaIndustry } from "react-icons/fa";

const responsiveStyles = `
  .mfg-header {
    display: flex;
    height: 110px;
    border-top: 1px solid #e5e5e5;
    border-bottom: 1px solid #e5e5e5;
  }

  .mfg-header-left {
    flex: 1.5;
    position: relative;
    background-size: cover;
    background-position: center;
    display: flex;
    align-items: center;
    padding: 0 20px;
  }

  .mfg-header-overlay {
    position: absolute;
    inset: 0;
    background: rgba(47,183,164,0.7);
  }

  .mfg-header-badge {
    position: relative;
    display: flex;
    align-items: center;
    gap: 12px;
    background: rgba(0,0,0,0.15);
    padding: 14px 22px;
    border-radius: 6px;
    color: #fff;
    width: 520px;
    max-width: 100%;
  }

  .mfg-header-icon-box {
    width: 36px;
    height: 36px;
    background: #1f7f73;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
  }

  .mfg-header-right {
    flex: 1;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    min-width: 0;
  }

  .mfg-header-right-deco-left {
    position: absolute;
    left: 0;
    top: 0;
    height: 100%;
    width: 80px;
    background: linear-gradient(135deg,#2fb7a4 30%,#2f6f9f 60%,#2f4a7f);
    clip-path: polygon(0 0, 60% 0, 0 100%);
  }

  .mfg-header-right-deco-right {
    position: absolute;
    right: 0;
    top: 0;
    height: 100%;
    width: 80px;
    background: linear-gradient(135deg,#2fb7a4 30%,#2f6f9f 60%,#2f4a7f);
    clip-path: polygon(100% 0, 100% 100%, 40% 100%);
  }

  .mfg-header-title {
    display: flex;
    align-items: center;
    gap: 12px;
    z-index: 1;
  }

  .mfg-header-title h2 {
    margin: 0;
    font-size: 30px;
    font-weight: 600;
    color: #243b64;
  }

  .mfg-main {
    display: flex;
    padding: 60px 80px;
    gap: 60px;
    align-items: center;
  }

  .mfg-image-wrap {
    flex: 1;
  }

  .mfg-image-wrap img {
    width: 100%;
    max-width: 650px;
    display: block;
  }

  .mfg-accordion {
    flex: 1.2;
  }

  .mfg-accordion-item {
    margin-bottom: 18px;
  }

  .mfg-accordion-header {
    background: linear-gradient(90deg,#2fb7a4 0%,#2f6f9f 60%,#2f4a7f);
    color: #f4f7fb;
    padding: 8px 24px;
    cursor: pointer;
    font-weight: 600;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .mfg-accordion-arrow {
    font-size: 22px;
    flex-shrink: 0;
    margin-left: 12px;
  }

  .mfg-accordion-body {
    padding: 20px;
    color: #555;
  }

  /* ── Tablet: 768px – 1024px ── */
  @media (max-width: 1024px) {
    .mfg-main {
      padding: 40px 40px;
      gap: 40px;
    }

    .mfg-header-badge {
      width: auto;
      font-size: 14px;
      padding: 10px 16px;
    }

    .mfg-header-title h2 {
      font-size: 24px;
    }
  }

  /* ── Mobile: ≤ 767px ── */
  @media (max-width: 767px) {
    .mfg-header {
      flex-direction: column;
      height: auto;
    }

    .mfg-header-left {
      flex: none;
      padding: 16px;
      min-height: 80px;
    }

    .mfg-header-badge {
      width: 100%;
      font-size: 13px;
      padding: 10px 14px;
      gap: 8px;
    }

    .mfg-header-right {
      flex: none;
      padding: 16px;
      min-height: 70px;
    }

    .mfg-header-right-deco-left,
    .mfg-header-right-deco-right {
      width: 50px;
    }

    .mfg-header-title h2 {
      font-size: 20px;
    }

    .mfg-main {
      flex-direction: column;
      padding: 30px 20px;
      gap: 30px;
    }

    .mfg-image-wrap {
      width: 100%;
    }

    .mfg-image-wrap img {
      max-width: 100%;
    }

    .mfg-accordion {
      width: 100%;
    }

    .mfg-accordion-header {
      padding: 10px 16px;
      font-size: 14px;
    }
  }

  /* ── Very small phones: ≤ 400px ── */
  @media (max-width: 400px) {
    .mfg-header-badge {
      font-size: 12px;
      padding: 8px 10px;
    }

    .mfg-header-title h2 {
      font-size: 17px;
    }

    .mfg-accordion-header {
      font-size: 13px;
      padding: 8px 12px;
    }

    .mfg-accordion-body {
      padding: 14px;
      font-size: 13px;
    }
  }
`;

function ManufacturingPage() {
  const [openIndex, setOpenIndex] = useState(null);

  useEffect(() => {
    const styleId = "mfg-responsive-styles";
    if (!document.getElementById(styleId)) {
      const tag = document.createElement("style");
      tag.id = styleId;
      tag.innerHTML = responsiveStyles;
      document.head.appendChild(tag);
    }
    return () => {
      const existing = document.getElementById(styleId);
      if (existing) existing.remove();
    };
  }, []);

  const toggle = (i) => {
    setOpenIndex(openIndex === i ? null : i);
  };

  const data = [
    {
      title: "1.Invoice Processing",
      content:
        "Invoice processing has numerous challenges such as invoices with formats; need consolidated data from numerous sources into the solitary financial database system etc. which can be automated with RPA."
    },
    {
      title: "2.Customer Service",
      content:
        "Automated customer care systems can category enquiries and offer initial responses to customers. The automated system can separate enquiries into different categories, like tech sector, service sector, and more."
    },
    {
      title: "3.Periodic Report Preparation",
      content:
        "auto-generate reports, analyze their contents, and further email them to relevant managers."
    },
    {
      title: "4.Price Comparison",
      content:
        "Robots can easily create a summary of prices and also extract data for the best pricing."
    },
    {
      title: "5.Data Validation",
      content:
        "Perform data validation tasks such as checking the accuracy and quality of source data before using, importing, or processing the data"
    }
  ];

  return (
    <div>

      {/* ===== HEADER ===== */}
      <div className="mfg-header">
        {/* LEFT */}
        <div
          className="mfg-header-left"
          style={{ backgroundImage: `url(${bannerImg})` }}
        >
          <div className="mfg-header-overlay" />

          <div className="mfg-header-badge">
            <div className="mfg-header-icon-box">
              <FaRobot style={{ color: "#fff", fontSize: "18px" }} />
            </div>

            <span>Artificial Intelligence - Use Cases</span>
            <span style={{ marginLeft: "auto" }}>›</span>
          </div>
        </div>

        {/* RIGHT */}
        <div className="mfg-header-right">
          <div className="mfg-header-right-deco-left" />
          <div className="mfg-header-right-deco-right" />

          <div className="mfg-header-title">
            <FaIndustry style={{ fontSize: "32px", color: "#2fb7a4" }} />

            <h2>Manufacturing</h2>
          </div>
        </div>
      </div>

      {/* ===== MAIN SECTION ===== */}
      <div className="mfg-main">
        {/* IMAGE */}
        <div className="mfg-image-wrap">
          <img src={manufacturingImg} alt="" />
        </div>

        {/* ACCORDION */}
        <div className="mfg-accordion">
          {data.map((item, i) => (
            <div key={i} className="mfg-accordion-item">
              <div
                className="mfg-accordion-header"
                onClick={() => toggle(i)}
              >
                {item.title}
                <span className="mfg-accordion-arrow">
                  {openIndex === i ? "↑" : "⌄"}
                </span>
              </div>

              {openIndex === i && (
                <div className="mfg-accordion-body">{item.content}</div>
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default ManufacturingPage;
